import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoggerService, SnackbarData, SnackbarMessageType, SnackbarService } from '@nx-fe/services';
import { XsI18nPipe } from '../../../../../../../../libs/pipes/src';
import { IDeviceContract } from '../../../../../../../../libs/services';
import { Enums } from '../../../../../../../../libs/services/enums/enums';
import { ServerError } from '../../../../shared/util/errors';
import { DeviceService } from '../services/device.service';

@Component({
  selector: 'app-dlg-confirm-action',
  templateUrl: './dlg-confirm-action.component.html',
  styleUrls: ['./dlg-confirm-action.component.scss'],
})
export class DlgConfirmActionComponent {
  deviceAction: Enums.DeviceActions;
  ui;

  private readonly logPrefix: string = 'DialogConfirmAction: ';
  private deviceContract: IDeviceContract;
  private localizedActionName: string;
  private actionName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private xs18: XsI18nPipe,
    private deviceService: DeviceService,
    private dialogRef: MatDialogRef<DlgConfirmActionComponent>,
    private $log: LoggerService,
    private snackbarService: SnackbarService
  ) {
    this.deviceAction = data.deviceAction;
    this.deviceContract = data.deviceContract;
    this.ui = {
      deviceName: this.deviceContract.deviceName,
      buttonText: this.xs18.transform('message_ActionSubmitButtonText_' + Enums.DeviceActions[this.deviceAction]),
      params: new FormGroup({
        phone: new FormControl(),
        message: new FormControl(),
        password: new FormControl(),
      }),
      checkForMacDevice: this.deviceContract.model ? this.deviceContract.model.indexOf('Mac') === 0 : false,
      // set flags to display input fields as needed
      bFormLock:
        this.deviceAction === Enums.DeviceActions.Lock && this.deviceContract.family === Enums.DeviceFamily.iOS,
      bFormWipe:
        this.deviceAction === Enums.DeviceActions.Wipe && this.deviceContract.family === Enums.DeviceFamily.iOS,
      bFormMsg: this.deviceAction === Enums.DeviceActions.SendMessage,
      bFormPwd: this.deviceAction === Enums.DeviceActions.ResetPasscode,
    };
    this.actionName = Enums.DeviceActions[this.deviceAction];
    this.localizedActionName = this.xs18.transform('label_' + this.actionName);
  }

  get deviceActions() {
    return Enums.DeviceActions;
  }

  get isWipeUnEnroll() {
    return this.deviceAction == this.deviceActions.Wipe || this.deviceAction == this.deviceActions.UnEnroll;
  }

  get paramsControls() {
    return this.ui.params.controls;
  }

  onDialogCancel() {
    this.dialogRef.close('cancel');
  }

  onDialogSubmit() {
    this.$log.debug(this.logPrefix + 'action submitted: ' + this.actionName);

    // if form data is not valid, don't proceed
    if (this.ui.params.invalid) {
      this.$log.error(this.logPrefix + 'form validation failed - action will not execute');
      return;
    }

    // close the window
    this.dialogRef.close('success');

    // execute the action
    this.deviceService.executeDeviceAction(this.deviceAction, this.deviceContract.deviceId, this.ui.params.value).then(
      () => {
        this.deviceService.actionListener.next(this.deviceAction);
        this.$log.debug(this.logPrefix + 'action promise resolved');
        this.snackbarService.showSnackbar({
          type: SnackbarMessageType.success,
          title: '',
          message: this.xs18.transform('message_ActionSent', this.localizedActionName),
        } as SnackbarData);
      },

      error => {
        this.$log.error(this.logPrefix + 'action promise rejected');
        // show descriptive error message
        const errorTitle = this.xs18.transform('message_ActionErrorTitle', this.localizedActionName);
        let errorText = this.xs18.transform('message_ActionGenericErrorText', this.localizedActionName);
        if (error instanceof ServerError) {
          if (error.is(Enums.ServerErrors.SecurityException)) {
            errorText = this.xs18.transform('message_ActionForbiddenErrorText', this.localizedActionName);
          } else if (error.is(Enums.ServerErrors.NotSupported)) {
            errorText = this.xs18.transform('message_ActionNotSupported', this.localizedActionName);
          }
        }

        this.snackbarService.showSnackbar({
          type: SnackbarMessageType.failure,
          title: errorTitle,
          message: errorText,
        } as SnackbarData);
      }
    );
  }
}
